import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CompanyPageStepVendorsComponent } from './company-page-step-vendors.component';

@NgModule({
  declarations: [CompanyPageStepVendorsComponent],
  imports: [CommonModule, FormsModule],
  exports: [CompanyPageStepVendorsComponent],
  entryComponents: [CompanyPageStepVendorsComponent]
})
export class CompanyPageStepVendorsModule { }
